import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ToolsService {
	Url = `${environment.apiUrl}`
	private previousUrl: string | null = null;
	private currentUrl: string | null = null;
	constructor(
		private http: HttpClient,
		private router: Router
	) { 
		this.currentUrl = this.router.url;
		this.router.events
		  .pipe(filter(event => event instanceof NavigationStart))
		  .subscribe((event: any) => {
			this.previousUrl = this.currentUrl;
			this.currentUrl = event.url;
		  });
	}

	contentUpdate(params: any){
		return this.http.post(this.Url + 'get-content-updates', {int_subject_ids:params})
	}

	public getPreviousUrl(): string | null {
		return this.previousUrl;
	}
}
